module.exports = __webpack_public_path__ + "static/media/anim_selo_copyright_updated.8553bd5b.gif";